class ImageGallery extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            effect: 'coverflow',
            centeredSlides: true,
            slidesPerView: 2,
            lazyLoadingInPrevNext: true,
            loop: true,
            navigation: {
                nextEl: '[data-gallery-next]',
                prevEl: '[data-gallery-prev]',
            },
            initialSlide: 2,
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 250,
                modifier: 1,
            },
            pagination: {
                el: '[data-gallery-pagination]',
                clickable: true
            },
            breakpoints: {
                980: {
                    slidesPerView: 3,
                    coverflowEffect: {
                        depth: 400
                    }
                }
            },
            autoplay: {
                delay: 4000,
                pauseOnMouseEnter: true
            },
            on: {
                beforeInit() {
                    const slides = this.el.querySelectorAll('.swiper-slide');

                    if (slides) {
                        if (slides.length <= 1) {
                            this.params.loop = false;
                            this.params.autoplay.enabled = false;
                            this.params.breakpoints = null;
                            this.params.coverflowEffect = null;
                            this.params.effect = 'slide';
                        }
                    }
                }
            }
        });
    }
}
